import React, { ReactElement, SVGProps } from 'react';

export const SvgYoutube = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg fill="none" height={45} width={45} {...props}>
      <circle fill="#25C5B0" r={22.5} cy={22.5} cx={22.5} />
      <path
        fill="#000"
        fillOpacity={0.01}
        d="M13.508 12.884H33.52v20.013H13.508z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.022 17.924c.5.504.663 1.648.663 1.648s.167 1.343.167 2.686v1.26c0 1.343-.167 2.685-.167 2.685s-.163 1.144-.663 1.648c-.571.596-1.205.657-1.563.692l-.107.011c-2.334.168-5.838.173-5.838.173s-4.336-.04-5.67-.167a3.769 3.769 0 00-.227-.03c-.423-.051-1.086-.13-1.613-.68-.5-.503-.662-1.647-.662-1.647s-.167-1.342-.167-2.686v-1.26c0-1.342.167-2.685.167-2.685s.162-1.144.662-1.648c.573-.596 1.207-.657 1.565-.692l.107-.01c2.333-.169 5.834-.169 5.834-.169h.007s3.5 0 5.835.168c.032.004.067.008.106.011.358.035.992.096 1.564.692zm-9.23 2.455v4.664l4.505-2.324z"
        fill="#fff"
      />
    </svg>
  );
};
